import { useTranslation } from "react-i18next";
import styled from "styled-components"
import { Button, Input, Select, setParamsFilter, Row, Col, message, AspectRatio, Modal, ImportButton, Divider, Typography, ExpandableText, Badge, ImageFileId } from "./../../../../ui/ot"
import {
    Carousel,
    CarouselContent,
    CarouselItem,
    CarouselNext,
    CarouselPrevious,
} from "../../../../ui/carousel"
import { useEffect, useState, useRef } from "react"
import { Link, useParams, useNavigate, useSearchParams } from "react-router-dom"
import { useItem } from "../../../controllers/ItemController"
import { useBib } from "../../../controllers/BibController"
import { ProTableOt } from "./../../../../ui/ot"
import { useProTableOt } from './../../../../utility/componentOt/controllers/ProtableOtController'
import { ItemForm } from "../item_form";
import { Plus, Pencil, Bookmark } from 'lucide-react';
import { useCRUDController } from "./../../../../ui/classify_structure/CRUDController";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExport } from '@fortawesome/free-solid-svg-icons';
import dayjs from 'dayjs';
import BookCoverManager from "../../../components/book_cover_manager";
import { COLLECTION_BARCODE_PREFIX_OPTIONS } from '../../../controllers/CollectionBarcodeOverviewController';

/**
 * 館藏維護（加入「館藏條碼代碼 + 條碼起訖號」篩選）
 *
 * 沿用館藏維護流程，使用原有固定代碼選項，並把
 * item_barcode_prefix / item_barcode_start / item_barcode_end 帶進 /koha/item 查詢。
 */

const BookDetailBarcodeFilter = ({
    keyPrefix = 'library.bookdetail',
    customColumns = [],
    holdingCustomColumns = []
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const [searchParams, setSearchParams] = useSearchParams();
    const bib_biblionumber = searchParams.get('bib_biblionumber');
    const [bookData, setBookData] = useState()
    const [bookImageData, setBookImageData] = useState([])
    const navigate = useNavigate()
    const onBefore = (value) => {
        // console.log('onBefore', value)
    }
    const onFinish = (value) => {
        // console.log('onFinish', value)
    }
    const bib_controller = useCRUDController({ apiRoute: "/koha/bib" })
    const [api, setApi] = useState()
    const [current, setCurrent] = useState(0)

    // 當輪播圖變化時更新當前索引
    const onSelect = () => {
        if (!api) return
        setCurrent(api.selectedScrollSnap())
    }

    // 設置輪播圖API並添加事件監聽器
    const setCarouselApi = (api) => {
        setApi(api)
        api.on("select", onSelect)
    }
    // 重新取得書目資料
    const refreshBookData = () => {
        getBibData({
            biblionumber: bib_biblionumber,
        }).then((response) => {
            let data = response?.data
            let firstData = data?.find(_ => true)
            let fileId = !!firstData?.bib_cover_images ? firstData?.bib_cover_images : []

            setBookImageData(() => {
                let file_id = (fileId || [])?.map((val) => {
                    return {
                        file_id: val
                    }
                })
                if (file_id.length > 0) {
                    return file_id
                }
                else {
                    return [
                        {
                            src: "https://media.taaze.tw/showLargeImageByIsbn.ashx?isbn=" + firstData?.bibitem_isbn
                        },
                    ]
                }
            })
            setBookData(firstData)
        })
    }
    const {
        BibData,
        getBibData,
        getBibInfoFormat
    } = useBib({
        onBefore,
        onFinish
    })
    useEffect(() => {
        refreshBookData()
        bib_controller.getData({
            biblionumber: bib_biblionumber,
            marcdata: "json"
        })
    }, [])
    return (
        <Row>
            {bib_biblionumber && (
                <Col span={24}>
                    <Row>
                        <Col span={24}>
                            <ButtonGroup>
                                <Button
                                    variant="outline"
                                    onClick={() => { window.open(`/library/backstage/AddMARC`, "_blank") }}
                                >
                                    <Plus size={16} />
                                    新增書目
                                </Button>
                                <Button variant="outline"
                                    onClick={() => { window.open(`/library/backstage/EditMARC?bib_biblionumber=${bib_biblionumber}`, "_blank") }}>
                                    <Pencil size={16} />
                                    編輯書目
                                </Button>

                                {/* <Button variant="outline" onClick={() => navigate('/library/backstage/Circulation/CirculationReserve/' + bib_biblionumber)}>
                        <Bookmark size={16} />
                        預約
                    </Button> */}
                            </ButtonGroup>
                        </Col>
                        <Col xxl={20} xl={20} lg={20} md={16} sm={24} xs={24} >
                            <Row gutter={[4, 4]}>
                                {
                                    getBibInfoFormat().map((value, index) => {
                                        if (value?.language_name === "bib_title") {
                                            return (
                                                <Col span={24} key={value?.language_name}>
                                                    <Typography.P style={{ marginBottom: 0 }} mt={0}>
                                                        <SubTitle>
                                                            {value?.valueKeys.map((keysValue) => bookData?.[keysValue])}
                                                        </SubTitle>
                                                    </Typography.P>
                                                </Col>
                                            )
                                        }
                                        else if (value?.language_name === "Language") {
                                            return (
                                                <Col xxl={4} xl={12} key={value?.language_name}>
                                                    <Typography.P style={{ marginBottom: 0 }} mt={0}>
                                                        {t(`${value?.language_name}`)}：
                                                        {value?.valueKeys.map((keysValue) => bookData?.[keysValue]?.['Language'])}
                                                    </Typography.P>
                                                </Col>
                                            )
                                        }
                                        else if (value?.language_name === "online_resources") {
                                            let bib_electronic_location = bookData?.bib_electronic_location
                                            let bib_electronic_location_name = bookData?.bib_electronic_location_name
                                            return (
                                                <Col xxl={4} xl={12} key={value?.language_name}>
                                                    <Typography.P style={{ marginBottom: 0 }} mt={0}>
                                                        {t(`${value?.language_name}`)}：
                                                        {bib_electronic_location && (
                                                            <Button
                                                                type="link"
                                                                onClick={() => {
                                                                    window.open(bib_electronic_location, 'blank')
                                                                }}
                                                            >
                                                                {bib_electronic_location_name}
                                                            </Button>
                                                        )}
                                                    </Typography.P>
                                                </Col>
                                            )
                                        }
                                        else {
                                            // 決定欄位寬度
                                            let span = value?.language_name === "Description" || value?.language_name === "Other_title" || value?.language_name === "Publication_details"
                                                ? { xxl: 24, xl: 24, lg: 24, md: 24, sm: 24, xs: 24 }
                                                : { xxl: 12, xl: 12, lg: 12, md: 12, sm: 12, xs: 24 };

                                            return (
                                                <Col {...span} key={value?.language_name}>
                                                    <Typography.P style={{ marginBottom: 0 }} mt={0}>
                                                        {t(`${value?.language_name}`)}：
                                                        {value?.valueKeys.map((keysValue) => {
                                                            if (value?.isJoin) {
                                                                return Array.isArray(bookData?.[keysValue])
                                                                    ? bookData?.[keysValue].join('、')
                                                                    : bookData?.[keysValue];
                                                            } else {
                                                                return bookData?.[keysValue];
                                                            }
                                                        })}
                                                    </Typography.P>
                                                </Col>
                                            )
                                        }
                                    })
                                }
                            </Row>
                            <Button type="link" onClick={() => {

                                Modal.info({
                                    width: '1000px',
                                    title: bookData?.bib_title,
                                    okText: "關閉",
                                    content: <>
                                        {
                                            bib_controller.ResponseData.map((value) => {
                                                return (
                                                    <Row>
                                                        <Col span={24}>
                                                            <Row>
                                                                <Col span={24}>
                                                                    <Row>
                                                                        <Col span={3}>
                                                                            leader
                                                                        </Col>
                                                                        <Col span={21}>
                                                                            {value?.metadata?.leader}
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                        <Col span={24}>
                                                            <Row>
                                                                {value?.metadata?.controlfield.map((field) => {
                                                                    return (
                                                                        <Col span={24}>
                                                                            <Row>
                                                                                <Col span={3}>
                                                                                    {field?.tag}
                                                                                </Col>
                                                                                <Col span={21}>
                                                                                    {field?.text}
                                                                                </Col>
                                                                            </Row>
                                                                        </Col>
                                                                    )
                                                                })}
                                                            </Row>
                                                        </Col>
                                                        <Col span={24}>
                                                            <Row gutter={[8, 8]}>
                                                                {value?.metadata?.datafield.map((field) => {
                                                                    return (
                                                                        <Col span={24}>
                                                                            <Row>
                                                                                <Col span={3}>
                                                                                    <Row gutter={[4, 4]}>
                                                                                        <Col>
                                                                                            {field?.tag}
                                                                                        </Col>
                                                                                        <Col>
                                                                                            {field?.ind1}
                                                                                        </Col>
                                                                                        <Col>
                                                                                            {field?.ind2}
                                                                                        </Col>
                                                                                    </Row>
                                                                                </Col>
                                                                                <Col span={21}>
                                                                                    <Row>
                                                                                        {
                                                                                            field?.subfield?.map((sub) => {
                                                                                                return (
                                                                                                    <Col span={24}>
                                                                                                        <Row gutter={[4, 4]} >
                                                                                                            <Col>
                                                                                                                {sub?.code}
                                                                                                            </Col>
                                                                                                            <Col>
                                                                                                                {sub?.text}
                                                                                                            </Col>
                                                                                                        </Row>
                                                                                                    </Col>
                                                                                                )
                                                                                            })
                                                                                        }
                                                                                    </Row>
                                                                                </Col>
                                                                            </Row>
                                                                        </Col>
                                                                    )
                                                                })}
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                )
                                            })


                                        }
                                    </>

                                })
                            }}>
                                Marc預覽
                            </Button>
                            {/* <div><GrayText>{t(`MARC preview`)}:</GrayText> Show</div>
                            <div><GrayText>{t(`MARC framework`)}:</GrayText> Default</div> */}
                        </Col>

                        <Col xxl={4} xl={4} lg={4} md={8} sm={24} xs={24}>
                            <Row justify="center" >
                                <Col xxl={24} xl={24} lg={24} md={24} sm={12} xs={20}>
                                    <Row gutter={[4, 4]}>
                                        <Col span={24}>
                                            <div className="w-full max-w-4xl mx-auto px-1">

                                                <Carousel
                                                    setApi={setCarouselApi}
                                                    className="w-full"
                                                    opts={{
                                                        align: "start",
                                                        loop: true,
                                                    }}
                                                >
                                                    <CarouselContent>
                                                        {bookImageData.map((book, index) => (
                                                            <CarouselItem key={book?.file_id || book?.src || index}>
                                                                <AspectRatio ratio={3 / 4} className="bg-muted relative">
                                                                    {
                                                                        book?.file_id ?
                                                                            <ImageFileId
                                                                                file_id={book?.file_id}
                                                                                className="w-full rounded-md object-cover"
                                                                            />
                                                                            :
                                                                            <>
                                                                                <ImageFileId
                                                                                    src={book?.src}
                                                                                    className="w-full rounded-md object-cover"
                                                                                />
                                                                                <div
                                                                                    style={{
                                                                                        position: "absolute",
                                                                                        bottom: 8,
                                                                                        left: 8,
                                                                                        background: "rgba(0,0,0,0.6)",
                                                                                        color: "#fff",
                                                                                        padding: "2px 8px",
                                                                                        borderRadius: "4px",
                                                                                        fontSize: "12px"
                                                                                    }}
                                                                                >
                                                                                    由網路開放API抓取
                                                                                </div>
                                                                            </>
                                                                    }
                                                                </AspectRatio>
                                                            </CarouselItem>
                                                        ))}
                                                    </CarouselContent>
                                                    <div className="flex items-center justify-center gap-2 mt-4">
                                                        <CarouselPrevious className="static transform-none" />
                                                        <div className="text-sm">
                                                            {current + 1} / {bookImageData.length}
                                                        </div>
                                                        <CarouselNext className="static transform-none" />
                                                    </div>
                                                </Carousel>

                                            </div>
                                        </Col>
                                        <Col span={24}>
                                            <BookCoverManager
                                                biblionumber={bib_biblionumber}
                                                title={bookData?.bib_title}
                                                isbn={bookData?.bibitem_isbn}
                                                initialFileIds={bookImageData.filter((image) => image?.file_id).map((image) => image.file_id)}
                                                buttonText="編輯圖片"
                                                buttonBlock
                                                onChanged={({ fileIds }) => {
                                                    setBookImageData(fileIds.length > 0
                                                        ? fileIds.map((file_id) => ({ file_id }))
                                                        : [{ src: "https://media.taaze.tw/showLargeImageByIsbn.ashx?isbn=" + bookData?.bibitem_isbn }])
                                                    setCurrent(0)
                                                }}
                                            />
                                        </Col>
                                    </Row>

                                </Col>

                            </Row>
                        </Col>
                        <Col span={24}>
                            <Divider></Divider>
                        </Col>
                    </Row>
                </Col>
            )}

            <Col span={24}>
                <Row gutter={[8, 8]}>
                    <Col span={24}>
                        <Typography.Title level={4}>
                            {t(`Holding`)}
                        </Typography.Title>
                    </Col>
                    <Col span={24}>
                        <HoldingProTableOt customColumns={[
                            ...holdingCustomColumns,]} bib_biblionumber={bib_biblionumber} />
                    </Col>
                </Row>
            </Col>
        </Row>
    )
}
const HoldingProTableOt = ({
    bib_biblionumber = 0,
    keyPrefix = "library.bookdetail",
    customColumns = []
}) => {
    // const { t } = useTranslation('translation')
    const { t } = useTranslation('translation', { keyPrefix })

    const actionRef = useRef()

    const [importDatas, setImportData] = useState([]);
    const [import_modal, set_import_modal] = useState(false);
    const [upload_modal, set_upload_modal] = useState(false)

    const columns = [
        {
            title: t(`Title`),
            dataIndex: 'bib_title',
            key: 'bib_title',
            width: 200,
            render: (text, record, index) => {
                return (<ExpandableText
                    text={`${record?.bib_title || ""}${record?.bib_subtitle || ""}`}
                    maxLines={2}>
                </ExpandableText>)

            }
        },

        {
            title: t(`Images`),
            dataIndex: 'file_id',
            key: 'file_id',
            sorter: false,
            width: 50,
            render: (text, record, index) => {
                if (!!text) {
                    return (<ImageFileId
                        file_id={text}
                        width={"50px"}
                    />)
                }
                else {
                    return ("-")
                }

            }
        },
        {
            title: t(`Item_type`),
            dataIndex: 'item_itype_description',
            key: 'item_itype_description',
        },
        {
            title: t(`Current library`),
            dataIndex: 'item_branchname_holding',
            key: 'item_branchname_holding',
        },
        {
            title: t(`Home library`),
            dataIndex: 'item_branchname_home',
            key: 'item_branchname_home',
        },
        {
            title: t(`Call_number`),
            dataIndex: 'item_itemcallnumber',
            key: 'item_itemcallnumber',
        },

        {
            title: t(`serial_enumeration_chronology`),
            dataIndex: 'item_serial_issue_number',
            key: 'item_serial_issue_number',
        },
        {
            title: t(`Status`),
            dataIndex: 'issue_cancheckout',
            key: 'issue_cancheckout',
            render: (text, record, index) => {
                let tags = ['item_damaged_authorised_values', 'item_notforloan_authorised_values', 'item_restricted_authorised_values', 'item_withdrawn_authorised_values']
                let statusCount = 0
                tags.forEach((ele) => {
                    if (!!record?.[ele]) {
                        statusCount++
                    }
                })
                console.log({
                    issue_cancheckout:record?.issue_cancheckout,

                })
                if (!!record?.issue_cancheckout) {
                    return <>
                        {t(`CanCheckout`)}
                    </>
                }
                else {
                    if (statusCount > 0) {
                        return (<>
                            不可借出
                            <p>
                                {record?.item_damaged_authorised_values && <Badge>
                                    {record?.item_damaged_authorised_values}
                                </Badge>}
                            </p>
                            <p>
                                {record?.item_notforloan_authorised_values && <Badge>
                                    {record?.item_notforloan_authorised_values}
                                </Badge>}
                            </p>
                            <p>
                                {record?.item_restricted_authorised_values && <Badge>
                                    {record?.item_restricted_authorised_values}
                                </Badge>}
                            </p>
                            <p>
                                {record?.item_withdrawn_authorised_values && <Badge>
                                    {record?.item_withdrawn_authorised_values}
                                </Badge>}
                            </p>

                        </>)
                    }
                    else {
                        return t(`CantCheckout`)
                    }

                }
            }
        },
        {
            title: t(`Last seen`),
            dataIndex: 'item_lastseen',
            key: 'item_lastseen',
        },
        {
            title: t(`Date accessioned`),
            dataIndex: 'item_dateaccessioned',
            key: 'item_dateaccessioned',
            render: (text, record, index) => {
                return <>
                    {dayjs(text).format("YYYY-MM-DD")}
                </>
            }
        },
        {
            title: t(`Date last borrowed`),
            dataIndex: 'item_datelastborrowed',
            key: 'item_datelastborrowed',
            render: (text, record, index) => {
                return <>
                    {text && dayjs(text).format("YYYY-MM-DD")}
                </>
            }
        },
        {
            title: t(`Barcode`),
            dataIndex: 'item_barcode',
            key: 'item_barcode',
            render: (text, record, index) => {
                return <>
                    <Link style={{
                        color: "blue"
                    }} to={
                        `/library/backstage/BookDetailItems?itemnumber=${record?.item_itemnumber}`
                    }>{text}</Link>
                </>
            }
        },
        {
            title: t(`Copy number`),
            dataIndex: 'item_copynumber',
            key: 'item_copynumber',
        },
        {
            title: t('attachment'),
            dataIndex: 'item_internal_notes',
            key: 'item_internal_notes',
        },
        ...customColumns,

    ];
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedRowsInfo, setSelectedRowsInfo] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);  //modal打開或關閉
    const [options, setOptions] = useState({
        withdrawn_options: [],
        call_number_source_options: [],
        damaged_options: [],
        restricted_options: [],
        notforloan_options: [],
        collection_options: [],
        library_options: [],
        location_options: [],
        shelving_control_number_options: [],
        item_type_options: []
    })
    const [search, setSearch] = useState({
        item_dateaccessioned_start: !bib_biblionumber ? dayjs().subtract(5, 'year').format('YYYY-MM-DD') : "",
        item_dateaccessioned_end: !bib_biblionumber ? dayjs().format('YYYY-MM-DD') : "",
    })
    // 條碼篩選：輸入中的條件（按下「查詢」才套用到 search，避免每敲一個字就打一次 API）
    const [barcodeInput, setBarcodeInput] = useState({
        item_barcode_prefix: undefined,
        item_barcode_start: "",
        item_barcode_end: "",
    })
    const [barcodeSelectResetKey, setBarcodeSelectResetKey] = useState(0)
    // 查詢結果筆數（給館員確認「這個代碼區間共幾筆」）
    const [resultTotal, setResultTotal] = useState(null)
    const resultRequestId = useRef(0)
    const applyBarcodeFilter = () => {
        const start = barcodeInput?.item_barcode_start.trim() || ""
        const end = barcodeInput?.item_barcode_end.trim() || ""
        if ([start, end].some(value => value !== "" && !/^[0-9]{1,65}$/.test(value))) {
            message.error('條碼起訖號須為最多 65 位的非負整數')
            return
        }
        const normalizedStart = start.replace(/^0+/, '') || '0'
        const normalizedEnd = end.replace(/^0+/, '') || '0'
        if (start !== "" && end !== "" && (normalizedStart.length > normalizedEnd.length ||
            (normalizedStart.length === normalizedEnd.length && normalizedStart > normalizedEnd))) {
            message.error('條碼起號不可大於迄號')
            return
        }
        resultRequestId.current += 1
        setResultTotal(null)
        setSearch((pre) => ({
            ...pre,
            item_barcode_prefix: barcodeInput?.item_barcode_prefix || undefined,
            item_barcode_start: start || undefined,
            item_barcode_end: end || undefined,
        }))
    }
    const clearBarcodeFilter = () => {
        resultRequestId.current += 1
        setResultTotal(null)
        setBarcodeInput({ item_barcode_prefix: undefined, item_barcode_start: "", item_barcode_end: "" })
        // 共用 Select 未傳入空值時會保留內部選項；清除條件時同步重設選單。
        setBarcodeSelectResetKey(previous => previous + 1)
        setSearch((pre) => ({
            ...pre,
            item_barcode_prefix: undefined,
            item_barcode_start: undefined,
            item_barcode_end: undefined,
        }))
    }
    const hasBarcodeFilter = !!search?.item_barcode_prefix || !!search?.item_barcode_start || !!search?.item_barcode_end
    //勾選的設定，之後可以改一下
    const rowSelection = {
        //不一定都是對id
        // 全選的
        onSelectAll: (selected, selectedRows, changeRows) => {
            let select_temp = [];
            let selectRow = [];
            select_temp = [...selectedRowKeys];
            selectRow = [...selectedRowsInfo];

            if (selected) {
                changeRows.map((value, key) => {
                    select_temp.push(value?.item_itemnumber); //這個要自己改掉 改成你的id key
                    selectRow.push(value);
                });
            } else {
                changeRows.map((value, key) => {
                    const index = select_temp.indexOf(value?.item_itemnumber);//這個要自己改掉 改成你的id key
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);
                });
            }
            setSelectedRowKeys(select_temp);
            setSelectedRowsInfo(selectRow);
        },
        // 單一勾選
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = [];
            let selectRow = [];
            select_temp = [...selectedRowKeys];
            selectRow = [...selectedRowsInfo];

            if (selected) {
                select_temp.push(record?.item_itemnumber);
                selectRow.push(record);
            } else {
                select_temp = select_temp.filter(
                    (key) => key !== record?.item_itemnumber
                );
                selectRow = selectRow.filter(
                    (row) => row?.item_itemnumber !== record?.item_itemnumber
                );
            }
            setSelectedRowKeys(select_temp);
            setSelectedRowsInfo(selectRow);
        },

    };

    const changeData = (record) => {
        let data_tmp = importDatas.filter(item => item.index != record.index);
        setImportData(data_tmp);
    }

    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "post") {
                message.success("新增成功");
                actionRef.current.reloadAndRest(); //table 重整，包含頁數回到第一頁 
            } else if (axiosMode === "patch") {
                message.success("修改成功");
                actionRef.current.reload();
            } else if (axiosMode === "delete") {
                message.success("刪除成功");
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([]); //table 重整，包含頁數回到第一頁 
                setSelectedRowsInfo([]);
            } else if (axiosMode === "import") {
                message.success("匯入成功");
                actionRef.current.reloadAndRest();
            }
        } else if (status === "error") {
            if (axiosMode === "post") {
                message.error("新增失敗");
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                message.error("修改失敗");
                actionRef.current.reload();
            } else if (axiosMode === "delete") {
                message.error("刪除失敗");
                actionRef.current.reloadAndRest();
            }
        }
        if (axiosMode !== "get") {
            setModalOpen(false);
        }
    };
    function convertBooleansToInts(obj) {
        if (Array.isArray(obj)) {
            return obj.map(convertBooleansToInts);
        }

        if (obj !== null && typeof obj === 'object') {
            const result = {};
            for (const key in obj) {
                const value = obj[key];
                if (typeof value === 'boolean') {
                    result[key] = value ? 1 : 0;
                } else if (typeof value === 'object') {
                    result[key] = convertBooleansToInts(value); // 遞迴處理巢狀結構
                } else {
                    result[key] = value;
                }
            }
            return result;
        }

        return obj;
    }
    const downloadTemplate = () => {
        const link = document.createElement('a');
        link.href = '/館藏資料清單.xlsx'; // public 資料夾中的路徑
        link.download = '館藏資料清單.xlsx';
        link.click();
    }
    const {
        transformData,
        getItemData,
        postItemData,
        patchItemData,
        deleteItemData,
        exportData,
        importData,
        downloadData,
        overData,
    } = useItem({
        onBefore: () => { },
        onFinish: onFinish
    })

    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
    } = useProTableOt({
        columns
    })
    const {
        getItem_ApiData
    } = useItem({

    })
    useEffect(() => {
        getItem_ApiData({
            itemnumber: "0"
        })
            .then((response) => {
                let datas = response?.data
                let firstData = datas?.find((ele) => true)
                setOptions((pre) => {
                    return {
                        withdrawn_options: firstData?.withdrawn_options,
                        call_number_source_options: firstData?.call_number_source_options,
                        damaged_options: firstData?.damaged_options,
                        restricted_options: firstData?.restricted_options,
                        notforloan_options: firstData?.notforloan_options,
                        collection_options: firstData?.collection_options,
                        library_options: firstData?.library_options,
                        location_options: firstData?.location_options,
                        shelving_control_number_options: firstData?.shelving_control_number_options,
                        item_type_options: firstData?.item_type_options,
                    }
                })
            })
    }, [])
    useEffect(() => {
        actionRef.current.onTableSearch()
    }, [search])
    return (
        <Row>
            <Col span={24}>
                <ProTableOt
                    searchParams={{ ...search }}
                    rowKey={'item_itemnumber'}
                    actionRef={actionRef}
                    columns={columns}
                    request={async (params = {}, sort, filter) => {
                        const requestId = ++resultRequestId.current
                        setResultTotal(null)
                        // setAxiosMode("get")
                        let newParams = {
                            ...search
                        };
                        let order = setOrders(sort)
                        newParams = {
                            // ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                            ...newParams,
                            order,
                            size: params.pageSize,
                            cur_page: params.current,
                            custom_filter_value: params.keyword ?? "",
                            keyword: params.keyword ?? "",
                            custom_filter_key: custom_filter_key,
                        };
                        newParams = setParamsFilter({
                            ...newParams,
                        });
                        // setPageSize(params?.pageSize ?? 20)
                        return getItemData({
                            biblionumber: bib_biblionumber,
                            ...newParams
                        }).then((response) => {
                            if (requestId !== resultRequestId.current) return response
                            if (response?.status === 'failed') {
                                message.error(response?.message || '館藏查詢失敗')
                                setResultTotal(null)
                                return response
                            }
                            setResultTotal(response?.total ?? response?.data_count ?? response?.data?.length ?? null)
                            return response
                        })
                    }}

                    toolBarRender={() => {
                        return ([
                            // ── 新增：館藏條碼代碼 + 條碼起訖號 ──────────────────────────
                            <Col span={24}>
                                <Row gutter={[8, 4]} align={"middle"}>
                                    <Col>
                                        <Typography.P>
                                            館藏條碼代碼:
                                        </Typography.P>
                                    </Col>
                                    <Col style={{ minWidth: "220px" }}>
                                        <Select
                                            key={barcodeSelectResetKey}
                                            allowClear={true}
                                            placeholder={"全部代碼"}
                                            value={barcodeInput?.item_barcode_prefix}
                                            onChange={(value) => {
                                                setBarcodeInput((pre) => ({ ...pre, item_barcode_prefix: value }))
                                            }}
                                            options={COLLECTION_BARCODE_PREFIX_OPTIONS}
                                        />
                                    </Col>
                                    <Col>
                                        <Typography.P>
                                            條碼號碼:
                                        </Typography.P>
                                    </Col>
                                    <Col>
                                        <Input
                                            placeholder={"起號，例 1234567"}
                                            value={barcodeInput?.item_barcode_start}
                                            onChange={(e) => {
                                                setBarcodeInput((pre) => ({ ...pre, item_barcode_start: e.target.value }))
                                            }}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") { applyBarcodeFilter() }
                                            }}
                                        />
                                    </Col>
                                    <Col>
                                        <Typography.Title level={4}>
                                            ~
                                        </Typography.Title>
                                    </Col>
                                    <Col>
                                        <Input
                                            placeholder={"迄號，例 1300000"}
                                            value={barcodeInput?.item_barcode_end}
                                            onChange={(e) => {
                                                setBarcodeInput((pre) => ({ ...pre, item_barcode_end: e.target.value }))
                                            }}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") { applyBarcodeFilter() }
                                            }}
                                        />
                                    </Col>
                                    <Col>
                                        <Button onClick={() => applyBarcodeFilter()}>
                                            查詢
                                        </Button>
                                    </Col>
                                    {hasBarcodeFilter &&
                                        <Col>
                                            <Button type={"icon"} onClick={() => clearBarcodeFilter()}>
                                                X
                                            </Button>
                                        </Col>
                                    }
                                    {hasBarcodeFilter && resultTotal !== null &&
                                        <Col>
                                            <Badge>符合條件共 {resultTotal} 筆</Badge>
                                        </Col>
                                    }
                                </Row>
                            </Col>,
                            // ── 以下為原有的購入日期區間篩選 ──────────────────────────
                            <Col span={24}>
                                <Row gutter={[4, 4]} align={"middle"}>
                                    <Col>
                                        <Typography.P>
                                            {t(`Date accessioned`)}:
                                        </Typography.P>
                                    </Col>
                                    <Col>
                                        <Input
                                            type="date"
                                            // granularity={"day"}
                                            // placeholder={t(`.time_start`)}
                                            format={"YYYY-MM-DD"}
                                            value={search?.item_dateaccessioned_start ? search?.item_dateaccessioned_start : ""}
                                            onChange={(e) => {
                                                setSearch((pre) => {
                                                    if (dayjs(e.target.value).isBefore(dayjs(pre?.item_dateaccessioned_end, "YYYY-MM-DD"))) {
                                                        return {
                                                            ...pre,
                                                            item_dateaccessioned_start: dayjs(e.target.value).format("YYYY-MM-DD"),
                                                        }
                                                    }
                                                    else {
                                                        return {
                                                            ...pre,
                                                            item_dateaccessioned_start: pre?.item_dateaccessioned_end,
                                                            item_dateaccessioned_end: e.target.value,
                                                        }
                                                    }

                                                })
                                            }}
                                        />
                                    </Col>
                                    <Col>
                                        <Typography.Title level={4}>
                                            ~
                                        </Typography.Title>
                                    </Col>
                                    <Col>
                                        <Input
                                            type="date"
                                            placeholder={t(`.time_end`)}
                                            format={"YYYY-MM-DD"}
                                            value={search?.item_dateaccessioned_end ? search?.item_dateaccessioned_end : ""}
                                            onChange={(e) => {
                                                setSearch((pre) => {
                                                    if ((dayjs(e.target.value)).isBefore(pre?.item_dateaccessioned_start)) {
                                                        return {
                                                            ...pre,
                                                            item_dateaccessioned_start: e.target.value,
                                                            item_dateaccessioned_end: pre?.item_dateaccessioned_start,
                                                        }
                                                    }
                                                    else {
                                                        return {
                                                            ...pre,
                                                            item_dateaccessioned_end: e.target.value,
                                                        }
                                                    }

                                                })
                                            }}
                                        />
                                    </Col>
                                    {(search?.item_dateaccessioned_start || search?.item_dateaccessioned_end) &&
                                        <Col>
                                            <Button
                                                type={"icon"}
                                                onClick={() => {
                                                    setSearch((pre) => {
                                                        return {
                                                            ...pre,
                                                            item_dateaccessioned_start: undefined,
                                                            item_dateaccessioned_end: undefined
                                                        }
                                                    })
                                                }}>
                                                X
                                            </Button>
                                        </Col>
                                    }
                                </Row>
                            </Col>,
                            // <Button>{t(`import_collection`)}</Button>,
                            <Button className='example' style={{ background: '#1565C0', color: '#ffffff' }} onClick={e => exportData({ ...search,'itemnumber_id_arr': selectedRowKeys, biblionumber: bib_biblionumber })}>
                                {t(`export_collection`)} <FontAwesomeIcon icon={faFileExport} style={{ marginLeft: '2px' }} />
                            </Button>
                            ,
                            bib_biblionumber && <ImportButton
                                handleDownload={e => downloadData()}
                                handleImport={e => {
                                    // e['columns'] = default_column.concat(extra_columns || []); 
                                    e['columns'] = columns
                                    e["biblionumber"] = bib_biblionumber
                                    e["biblio_id"] = bib_biblionumber
                                    importData(e)
                                    set_upload_modal(false)
                                    set_import_modal(false)
                                }}
                                set_upload_modal={set_upload_modal}
                                upload_modal={upload_modal}
                                importData={importDatas}
                                setImportData={setImportData}
                                import_modal={import_modal}
                                set_import_modal={set_import_modal}
                                handleReserve={e => patchItemData(e)}
                                handleOver={e => overData(e)}
                                columns={[...columns, {
                                    title: '保留/覆蓋',
                                    align: 'center',
                                    render: (text, record, index) => {
                                        if (record.type == 'name') {
                                            return (
                                                <>
                                                    <Button type="text" style={{ color: '#4CAF50' }} onClick={e => { changeData(record) }}>保留</Button>
                                                </>)
                                        } else if (record.type == 'both') {
                                            return (
                                                <>
                                                    <Button type="text" style={{ color: 'rgba(43, 193, 123, 1)' }} onClick={e => { patchItemData([record]); changeData(record) }}>覆蓋</Button>
                                                </>
                                            )
                                        }
                                    }
                                }]}
                            />,
                        ])
                    }}
                    check={check}
                    setCheck={setCheck}
                    rowSelection={{
                        type: "checkbox",
                        selectedRowKeys: selectedRowKeys,
                        selectedRowsInfo: selectedRowsInfo,
                        ...rowSelection,
                        setSelectedRowKeys: setSelectedRowKeys,
                        setSelectedRowsInfo: setSelectedRowsInfo
                    }}

                    propsPatchOnBefore={(record) => {
                        return { ...record }
                    }}
                    PropsPatchForm={<ItemForm
                        propsOptions={options}
                        isPropsOptions={true}
                        isSerial={false}
                        syncCopyNumberOnGenerate={false}
                    />}
                    propsUseData={() => {
                        return {
                            postData: (data) => {
                                let newData = data?.map((val) => {
                                    return {
                                        ...val,
                                        biblionumber: bib_biblionumber,
                                        biblio_id: bib_biblionumber,
                                        internal_notes: val?.item_internal_notes,
                                        purchase_price: val?.purchase_price || null,
                                        replacement_price: val?.replacement_price || null,
                                        replacement_price_date: val?.replacement_price_date || null,
                                    }
                                })
                                postItemData(newData)
                            },
                            patchData: (data) => {
                                let output = data.map(convertBooleansToInts);
                                let newData = output?.map((val) => {
                                    return {
                                        ...val,
                                        not_for_loan_status: val?.not_for_loan_status ?? 0,
                                        collection_code: val?.collection_code ?? 0,
                                        restricted_status: val?.restricted_status ?? 0,
                                        damaged_status: val?.damaged_status ?? 0,
                                        withdrawn: val?.withdrawn ?? 0,
                                        itemnumber: val?.item_itemnumber,
                                        purchase_price: val?.purchase_price || null,
                                        replacement_price: val?.replacement_price || null,
                                        replacement_price_date: val?.replacement_price_date || null,
                                    }
                                })
                                patchItemData(newData)
                            },
                            deleteData: (data) => {
                                let newdeleteData = data?.map((val) => {
                                    return {
                                        ...val,
                                        itemnumber: val?.item_itemnumber,
                                    }
                                })
                                deleteItemData(newdeleteData)
                            },
                        }
                    }}
                    propsPatch={true}
                    propsPatchProcess={(record) => {
                        let newRecord = transformData(record)
                        return { ...newRecord }
                    }}
                    modalOpen={modalOpen}
                    setModalOpen={setModalOpen}
                    propsDelete={true}
                    propsPatchOnFinish={({ axiosMode, status }) => {
                        if (status === "success") {
                            actionRef.current.reload()
                        } else {

                        }
                    }}

                    propsPost={!!bib_biblionumber}
                    // propsPostOnBefore
                    initialValues={
                        {
                            biblionumber: bib_biblionumber
                        }
                    }
                    propsWidth={1500}
                    formMode={true}
                />
            </Col>
        </Row>
    )
}

const MainContainer = styled.div`
width: 100%;
display: flex;
-webkit-box-pack: center;
justify-content: space-around;
flex-direction: column;
-webkit-box-align: start;
align-items: start;
padding: 2em;
gap: 0.5em;
-webkit-flex-wrap: wrap;
`

const SubTitle = styled.div`
text-align: left;
// width: 90%;
font-size: 1.2em;
font-weight: 600;
}
`

const ButtonGroup = styled.div`
width: 100%;
display: flex;
gap: 1em;
align-items: flex-start;
`

const WhiteBox = styled.div`
background-color: #fff;
padding: 1em;
width: 100%;
`

const GrayText = styled.span`
color: #929292;
`

export default BookDetailBarcodeFilter
